import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import { Relayout, RelayoutItem, RelayoutWrapper } from 'relayout'

import { homeLoadPage } from 'actions/home'
import EventDraftList from 'components/event-draft-list'
import Loader from 'components/loader'
import EmptyEvents from 'components/empty-events'
import { getDraftSetupforms, isFetchingSetupforms } from 'selectors/home'
import { getPartnerPermissions } from 'selectors/entities'
import { getCurrentPartner } from 'selectors/settings'
import { getPartnerUrl } from 'utils/urls'

import styles from './drafts-page.css'

export class DraftsPage extends Component {

  componentDidMount() {
    const { params } = this.props

    // Reuse the homeLoadPage action until we split up entity sagas
    this.props.homeLoadPage(params.partnerId)
  }

  hasLoaded() {
    return !this.props.isFetchingSetupforms
  }

  hasDrafts() {
    return this.props.draftSetupforms.length > 0
  }

  renderLoader() {
    return (
      <div styleName="centered">
        <Loader center />
      </div>
    )
  }

  renderEmptyEvents() {
    const { partnerId } = this.props.params
    const { canAddEvents } = this.props
    return (
      <div styleName="centered">
        <EmptyEvents
          action="Create an event"
          description={
            <span>Welcome to your Drafts page.<br />
            Once you start creating events, they'll appear here until you submit them.</span>
          }
          link={canAddEvents ? getPartnerUrl(partnerId, '/sf/new') : null}
        />
      </div>
    )
  }

  renderDrafts() {
    const { draftSetupforms, params } = this.props
    return (
      <RelayoutWrapper>
        <Relayout align="center">
          <RelayoutItem xl="10">
            <EventDraftList
              events={draftSetupforms}
              partnerId={params.partnerId}
              title="Drafts"
              subtitle="Events you've yet to finish creating"
            />
          </RelayoutItem>
        </Relayout>
      </RelayoutWrapper>
    )
  }

  render() {
    const hasLoaded = this.hasLoaded()
    const hasDrafts = hasLoaded && this.hasDrafts()

    return (
      <div styleName="page">
        {!hasLoaded && this.renderLoader()}
        {hasLoaded && !hasDrafts && this.renderEmptyEvents()}
        {hasLoaded && hasDrafts && this.renderDrafts()}
      </div>
    )
  }

}

DraftsPage.propTypes = {
  canAddEvents: PropTypes.bool,
  draftSetupforms: PropTypes.array,
  homeLoadPage: PropTypes.func,
  isFetchingSetupforms: PropTypes.bool,
  params: PropTypes.object,
}

const mapStateToProps = (state, ownProps) => {
  const partner = getCurrentPartner(state)

  return {
    draftSetupforms: getDraftSetupforms(ownProps.params.partnerId)(state),
    isFetchingSetupforms: isFetchingSetupforms(state),
    canAddEvents: partner && getPartnerPermissions(ownProps.params.partnerId)(state).canAddEvents,
  }
}

const mapDispatchToProps = { homeLoadPage }

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(DraftsPage, styles))



/** WEBPACK FOOTER **
 ** ./src/containers/drafts-page/drafts-page.js
 **/